/* ============================================================
   BLINKIE PETS — front-end interactions
   Home page: sparkle mouse-trail, lifestyle finder tabs,
   auto-rotating reviews. Written to survive Shopify's theme
   editor (re-inits on shopify:section:load).
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SPARK = '<svg width="11" height="11" viewBox="0 0 24 24" fill="#E8A8BB"><path d="M12 0 C12.8 7 17 11.2 24 12 C17 12.8 12.8 17 12 24 C11.2 17 7 12.8 0 12 C7 11.2 11.2 7 12 0 Z"></path></svg>';

  /* ---- Hero sparkle trail ---- */
  function initHeroTrail(root) {
    var heroes = (root || document).querySelectorAll('[data-bp-hero][data-bp-trail]');
    heroes.forEach(function (hero) {
      if (hero.dataset.bpTrailBound) return;
      if (reduceMotion || !window.matchMedia('(pointer: fine)').matches) return;
      hero.dataset.bpTrailBound = '1';
      var last = 0;
      hero.addEventListener('mousemove', function (e) {
        var now = Date.now();
        if (now - last < 120) return;
        last = now;
        var rect = hero.getBoundingClientRect();
        var s = document.createElement('span');
        s.setAttribute('aria-hidden', 'true');
        s.style.cssText = 'position:absolute;pointer-events:none;z-index:5;left:' +
          (e.clientX - rect.left) + 'px;top:' + (e.clientY - rect.top) +
          'px;animation:bp-trail .9s ease-out forwards;';
        s.innerHTML = SPARK;
        hero.appendChild(s);
        setTimeout(function () { s.remove(); }, 950);
      });
    });
  }

  /* ---- Lifestyle finder tabs ---- */
  function initFinder(root) {
    var finders = (root || document).querySelectorAll('[data-bp-finder]');
    finders.forEach(function (finder) {
      if (finder.dataset.bpFinderBound) return;
      finder.dataset.bpFinderBound = '1';
      var tabs = finder.querySelectorAll('[data-bp-finder-tab]');
      var panels = finder.querySelectorAll('[data-bp-finder-panel]');
      var stage = finder.querySelector('.bp-finder') || finder;
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var idx = tab.getAttribute('data-bp-finder-tab');
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          panels.forEach(function (p) {
            if (p.getAttribute('data-bp-finder-panel') === idx) { p.removeAttribute('hidden'); }
            else { p.setAttribute('hidden', ''); }
          });
          var tint = tab.getAttribute('data-tint');
          if (tint) stage.style.background = tint;
        });
      });
    });
  }

  /* ---- Auto-rotating reviews ---- */
  function initReviews(root) {
    var blocks = (root || document).querySelectorAll('[data-bp-reviews]');
    blocks.forEach(function (block) {
      if (block.dataset.bpReviewsBound) return;
      block.dataset.bpReviewsBound = '1';
      var dataEl = block.querySelector('[data-bp-reviews-data]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!data || data.length < 1) return;
      var quote = block.querySelector('[data-bp-quote]');
      var credit = block.querySelector('[data-bp-credit]');
      var dots = block.querySelectorAll('[data-bp-dot]');
      var interval = parseInt(block.getAttribute('data-interval'), 10) || 6000;
      var idx = 0;
      var timer = null;

      function show(i) {
        idx = i;
        var r = data[i];
        if (quote) {
          quote.style.opacity = '0';
          setTimeout(function () {
            quote.textContent = '"' + r.text + '"';
            quote.style.opacity = '1';
          }, reduceMotion ? 0 : 200);
        }
        if (credit) credit.textContent = r.credit;
        dots.forEach(function (d, di) { d.setAttribute('data-on', di === i ? 'true' : 'false'); });
      }
      function next() { show((idx + 1) % data.length); }
      function start() { if (data.length > 1 && !reduceMotion) timer = setInterval(next, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          stop();
          show(parseInt(d.getAttribute('data-bp-dot'), 10));
          start();
        });
      });
      start();
    });
  }

  function initAll(root) {
    initHeroTrail(root);
    initFinder(root);
    initReviews(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor: re-init the section that just (re)loaded */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
